import { APP } from '_pixiSrc/globals';
import Requests from './Requests';
import DynamicData from '../ui/DynamicData';
import GameData from '../ui/GameData';
import GameConfig from '../libraries/GameConfig';
import {
    getUserData, setBet, setUserData, setWallet,
} from './Session';
import {
    SYMBOL_ID,
    REELS,
    GAME_DATA_KEY,
    GAME_PROPERTY_KEY,
    GAME_ID,
    ERROR,
    GAMBLE_CARD_COLOR,
    RANDOM_STRING,
} from '../Constants';

let gambleCount = 0;
let lastResult;
let expandingSymbol;
let expandingFreeSpinWinResult;
let expandingSymbolResult;
let GGHistory = [];
let clientId;

let betArray = [5, 10, 50, 200, 500, 1000, 5000];
let selectedBetIndex = 0;

/**
 * @class NetworkController
 * static class that implements server and client communication
 */
class NetworkController {
    /**
   * @name randomString
   * @param length
   * @description generate random string of given length
   */
    static randomString(length) {
        let text = '';
        const possible = RANDOM_STRING;
        /**
     * generate random string
     */
        for (let i = 0; i < length; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    }

    /**
   * check token is available in url params
   * if token is available return token
   * else so error message
   */
    static getToken() {
        // if (Utils.parseGet().token) {
        //     return Utils.parseGet().token;
        // } else {
        //     APP.displayGlobalError(ERROR.TOKEN_UNDEFINED, null);
        // }
        return '';
    }

    /**
   * @name getSpinResult
   * @description get spin response from server and set game data
   */
    static getSpinResult(res) {
        gambleCount = 0;
        Requests.spin()
            .then((response) => {
                /**
         * get view zone from server response
         * convert that view zone into game code
         */
                const array = [];
                for (const key in response.viewZone) {
                    if (response.viewZone[key].symbols) {
                        const reel = [];
                        for (let i = 0; i < 3; i++) {
                            let symbol;
                            if (response.viewZone[key].stopAt === 0) {
                                symbol = this.convertSymbolsIdToNumber(
                                    response.viewZone[key].symbols[i],
                                );
                            } else {
                                symbol = this.convertSymbolsIdToNumber(
                                    response.viewZone[key].symbols[(response.viewZone[key].stopAt + i) % (response.viewZone[key].symbols.length)],
                                );
                            }
                            reel.push(symbol);
                        }
                        array.push(reel);
                    }
                }

                DynamicData.setData(GAME_DATA_KEY.SPECIALSPIN, response.specialSpinData ? response.specialSpinData : {});

                /**
         * set current wallet balance
         */
                DynamicData.setValue(GAME_DATA_KEY.COINS, response.wallet.chips);

                /**
         * set current total bet
         */
                DynamicData.addValue(GAME_DATA_KEY.TOTALBET, response.game.betAmount - DynamicData.getValue(GAME_DATA_KEY.TOTALBET));

                /**
         * set winning data
         */
                DynamicData.setData(GAME_DATA_KEY.WIN, response.wins);

                const params = getUserData();
                params.wallet = response.wallet.chips;
                // params.freeSpinData = response.freeSpinData;
                setUserData(params);
                /**
         * check user wins free spin or not
         * if user wins free spin then
         * set free spin data game session
         */
                if (response.freeSpinData && response.freeSpinData.isFreeSpinAwarded) {
                    expandingSymbol = response.freeSpinData.pickedSymbol;
                    DynamicData.setData(GAME_DATA_KEY.FREESPIN, response.freeSpinData);
                    GameData.setProperty(GAME_PROPERTY_KEY.FREEGAMEPRESTART, true);
                } else if (response.freeSpinData.freeSpins && !response.freeSpinData.isFreeSpinAwarded) {
                    expandingSymbol = response.freeSpinData.pickedSymbol;
                    DynamicData.setData(GAME_DATA_KEY.FREESPIN, response.freeSpinData);
                    GameData.setProperty(GAME_PROPERTY_KEY.FREEGAME, true);
                }

                /**
         * get gamble win card history
         * convert in to game code and set card history
         */
                if (response.gamble && response.gamble.history) {
                    const history = [];
                    response.gamble.history.forEach((item) => {
                        history.push(NetworkController.convertGambleCardToNumber(item));
                    });
                    GGHistory = history;
                }

                /**
         * check expand data is available or not
         * if expand data is available then
         * convert expand data into game code and set that expand data
         */
                if (response.expandData) {
                    const expand = [0, 0, 0, 0, 0];
                    for (const key in response.expandData) {
                        switch (key) {
                            case REELS.REEL1:
                                expand[0] = 1;
                                break;
                            case REELS.REEL2:
                                expand[1] = 1;
                                break;
                            case REELS.REEL3:
                                expand[2] = 1;
                                break;
                            case REELS.REEL4:
                                expand[3] = 1;
                                break;
                            case REELS.REEL5:
                                expand[4] = 1;
                                break;
                        }
                    }
                    expandingSymbolResult = expand;
                } else {
                    expandingSymbolResult = [];
                }

                /**
         * check expand winning data is available or not
         * if expand winning is available then
         * set expand winning data
         */
                if (response.wins.expandedWins) {
                    expandingFreeSpinWinResult = response.wins.expandedWins.expandedWinLines;
                } else {
                    expandingFreeSpinWinResult = [];
                }

                res(array);
            })
            .catch((err) => {
                DynamicData.setData(GAME_DATA_KEY.WIN, { winCoins: 0, winLines: [], winLinesCount: 0 });
                res(GameConfig.wheelStopPositions);
                if (err.isError) {
                    console.error(`Error: ${err.data.error}`);
                } else {
                    APP.displayGlobalError(ERROR.SOMETHING_WENT_WRONG);
                    console.error(`Wrong response on spin: ${err}`);
                }
            });
    }

    /**
   * @name increaseBet
   * @description increase bet
   */
    static increaseBet(callback) {
        selectedBetIndex++;
        if (selectedBetIndex >= betArray.length) {
            selectedBetIndex = 0;
        }
        const currentBet = betArray[selectedBetIndex];
        const response = {
            currentBet,
            totalBet: currentBet * 10,
        };
        setBet(currentBet);
        callback(response);
    }

    /**
   * @name decreaseBet
   * @description decrease bet
   */
    static decreaseBet(callback) {
        selectedBetIndex--;
        if (selectedBetIndex < 0) {
            selectedBetIndex = betArray.length - 1;
        }
        const currentBet = betArray[selectedBetIndex];
        const response = {
            currentBet,
            totalBet: currentBet * 10,
        };
        setBet(currentBet);
        callback(response);
    }

    /**
   * @name maxBet
   * @description set maximum bet
   */
    static maxBet(callback) {
        selectedBetIndex = betArray.length - 1;
        const currentBet = betArray[selectedBetIndex];
        const response = {
            currentBet,
            totalBet: currentBet * 10,
        };
        setBet(currentBet);
        callback(response);
    }

    /**
   * @name getFreeSpinWinResultExpanding
   * @description get free spin expanding win data, convert into game code and return that data
   */
    static getFreeSpinWinResultExpanding() {
        const out = [];

        /**
     * get all paylines and view zone
     */
        const paylines = GameConfig.paylines;
        const viewZone = GameConfig.viewZone;

        /**
     * check user is winning after expanding symbol
     */
        if (expandingFreeSpinWinResult) {
            /**
       * convert expanded winning data in game code
       */
            for (const item of expandingFreeSpinWinResult) {
                if (item.winLineId) {
                    const current = paylines[item.winLineId];
                    const animationMap = [
                        [0, 0, 0],
                        [0, 0, 0],
                        [0, 0, 0],
                        [0, 0, 0],
                        [0, 0, 0],
                    ];
                    const tempOutput = {
                        line: current.paylineNumber,
                        lineLength: parseInt(item.winType.charAt(0)),
                        symbolNumber: this.convertSymbolsIdToNumber(item.symbolId),
                    };
                    for (let j = 0; j < expandingSymbolResult.length; j++) {
                        if (expandingSymbolResult[j] === 1) {
                            animationMap[j] = [1, 1, 1];
                        }
                    }
                    tempOutput.result = animationMap;
                    out.push(tempOutput);
                }
            }
        }
        return out;
    }

    /**
   * @name getExpandingValue
   * @description return expanding symbol
   */
    static getExpandingValue() {
        return this.convertSymbolsIdToNumber(expandingSymbol);
    }

    /**
   * @name getExpandingWheels
   * @description return expanding reel where symbols can expand
   */
    static getExpandingWheels(res) {
        return GameData.getProperty(GAME_PROPERTY_KEY.FREEGAME) ? res([1, 1, 1, 1, 1]) : res([0, 0, 0, 0, 0]);
    }

    /**
   * @name getExpandingSymbolResult
   * @description get sequence of expansions
   */
    static getExpandingSymbolResult(symbol, wheelRes, callback) {
        const symbols = [];

        const expandingMap = [
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0],
        ];

        for (let i = 0; i < expandingSymbolResult.length; i++) {
            if (expandingSymbolResult[i] === 1) {
                expandingMap[i] = expandingMap[i].map(() => 1);
            }
        }

        let animSpeed = 0.4;

        wheelRes.forEach((wh, wheelN) => {
            for (let i = 0; i < wh.length; i++) {
                const e = wh[i];
                if (e === symbol) {
                    for (let j = 0; j < wh.length; j++) {
                        if (wh[j] !== symbol) {
                            const symbolN = j + 1;
                            if (expandingMap[wheelN][symbolN - 1]) {
                                symbols.push({
                                    wheelN,
                                    symbolN,
                                    newSymbol: symbol,
                                    animSpeed,
                                });
                                animSpeed += GameConfig.expandingAcceleration;
                            }
                        }
                    }

                    break; // if at least one character in the series, then the expansion is done only once for the entire series
                }
            }
            animSpeed = 0.4;
        });

        callback(symbols);
    }

    /**
   * @name normalizeStartingParams
   * @description request starting parameters from the server and set game parameters when user enter first time in the game
   */
    static normalizeStartingParams(callback) {
        clientId = NetworkController.randomString(32);
        Requests.startingParams(clientId)
            .then((response) => {
                /**
         * set selectable bet lines
         */
                const lines = DynamicData.getData(GAME_DATA_KEY.LINES);
                lines.max = (response.maxChosenPayLinesAmount * 1) || 10;

                /**
         * check paytable is available or not
         * if available then get paytable data from response and convert into game code
         * set paytable data in session
         */
                const payTable = [];
                if (response.game.payTable) {
                    for (const key in response.game.payTable) {
                        if (response.game.payTable[key][5]) {
                            const num = this.convertSymbolsIdToNumber(key);
                            const temp = [];
                            for (let i = 2; i <= 5; i++) {
                                if (response.game.payTable[key][i] && response.game.payTable[key][i].multiplier) {
                                    temp.push(response.game.payTable[key][i].multiplier);
                                } else {
                                    temp.push(0);
                                }
                            }
                            payTable[num] = temp;
                        }
                    }
                }
                GameConfig.symbolIncome = payTable;

                /**
         * check paylines data is available or not
         * if available then get all paylines data from response and
         * set paylines data in session
         */
                const paylines = {};
                let paylineNumber = 0;
                if (response.game.payArray) {
                    for (const item of response.game.payArray) {
                        item.paylineNumber = paylineNumber;
                        paylines[item._id] = item;
                        paylineNumber++;
                    }
                }
                GameConfig.paylines = paylines;

                /**
         * set viewzone in session
         */
                GameConfig.viewZone = response.game.viewZone.toString();

                if (response.game.bigWins) {
                    GameConfig.bigWinsObj = response.game.bigWins;
                }

                DynamicData.setData(GAME_DATA_KEY.SPECIALSPIN, response.userDetails.specialSpinData ? response.userDetails.specialSpinData : {});

                DynamicData.setValue(GAME_DATA_KEY.BET, response.userDetails.currentBet);
                betArray = response.userDetails.game.settings.bets;
                selectedBetIndex = betArray.findIndex(b => b === Number(response.userDetails.currentBet));

                DynamicData.setValue(GAME_DATA_KEY.LINES, response.userDetails.currentLines);

                DynamicData.setValue(GAME_DATA_KEY.TOTALBET, response.userDetails.totalBet);

                const data = getUserData();
                DynamicData.setValue(GAME_DATA_KEY.COINS, data.wallet);

                GameData.setProperty(GAME_PROPERTY_KEY.TURBOCHECKED, true);

                if (response.userDetails.freeSpinData.freeSpins) {
                    expandingSymbol = response.userDetails.freeSpinData.pickedSymbol;
                    GameData.setProperty(GAME_PROPERTY_KEY.FREEGAME, true);
                    DynamicData.setData(GAME_DATA_KEY.FREESPIN, response.userDetails.freeSpinData);
                    DynamicData.setValue(GAME_DATA_KEY.FREEGAMECOUNTERMAX, response.userDetails.freeSpinData.freeSpins);
                    DynamicData.setValue(GAME_DATA_KEY.FREEGAMEWIN, response.userDetails.freeSpinData.winAmount);
                }

                if (callback) { callback(); }
            })
            .catch((err) => {
                APP.displayGlobalError(ERROR.SOMETHING_WENT_WRONG);
                console.error(`Wrong response on game click: ${err}`);
            });
    }

    /**
   * @name convertSymbolsIdToNumber
   * @description convert symbol id which received from the server into the game code
   */
    static convertSymbolsIdToNumber(symbol) {
        switch (symbol) {
            case SYMBOL_ID.TEN:
                return 0; // 10
            case SYMBOL_ID.J:
                return 1; // J
            case SYMBOL_ID.Q:
                return 2; // Q
            case SYMBOL_ID.K:
                return 3; // K
            case SYMBOL_ID.A:
                return 4; // A
            case SYMBOL_ID.GOD:
                return 5; // God
            case SYMBOL_ID.HUNTER:
                return 6; // Hunter
            case SYMBOL_ID.TUTANKHAMON:
                return 7; // Tutankhamon
            case SYMBOL_ID.SCARAB:
                return 8; // Scarab
            case SYMBOL_ID.WILD:
                return 9; // Wild
            case SYMBOL_ID.SCATTER:
                return 10; // Scatter
        }
    }

    /**
   * @name convertGambleCardToNumber
   * @description convert gamble card name which received from the server into the game card number
   */
    static convertGambleCardToNumber(card) {
        switch (card) {
            case GAMBLE_CARD_COLOR.RED:
                return 0;
            case GAMBLE_CARD_COLOR.BLACK:
                return 1;
        }
    }

    /**
   * @name convertNumberToGambleCard
   * @description convert game card number into the gamble card name
   */
    static convertNumberToGambleCard(id) {
        switch (id) {
            case 0:
                return GAMBLE_CARD_COLOR.RED;
            case 1:
                return GAMBLE_CARD_COLOR.BLACK;
        }
    }

    /**
   * @name getGambleHistory
   * @description convert game card number into the gamble card name
   */
    static getGambleHistory(req) {
        req(GGHistory);
    }

    /**
   * @name getGambleGameResult
   * @description get gamble data form server
   */
    static getGambleGameResult(cardType, req) {
        const isWon = Math.round(Math.random());
        if (!isWon) {
            gambleCount = 0;
            req({
                gambleCount: 0,
                gambleWon: false,
                gambleTotalAmount: 0,
                gambleHistory: [],
                wallet: { chips: getUserData().wallet },
                isGambleAvailable: false,
            });
        } else {
            gambleCount++;
            const winCoins = DynamicData.getData(GAME_DATA_KEY.WIN).winCoins;
            req({
                gambleCount,
                gamblePotentialWinAmount: winCoins * 2,
                gambleBetAmount: winCoins,
                gambleWon: true,
                gambleTotalAmount: winCoins,
                gambleHistory: [],
                wallet: { chips: getUserData().wallet },
                isGambleAvailable: (gambleCount < 5),
            });
        }

        // const token = NetworkController.getToken();
        // cardType = NetworkController.convertNumberToGambleCard(cardType);
        // Requests.gambleGame(token, GAME_ID, clientId, cardType)
        //     .then((response) => {
        //         /**
        //  * get gamble win card history
        //  * convert in to game code and set card history
        //  */
        //         if (response.gambleHistory) {
        //             const history = [];
        //             response.gambleHistory.forEach((item) => {
        //                 history.push(NetworkController.convertGambleCardToNumber(item));
        //             });
        //             GGHistory = history;
        //         }
        //         req(response);
        //     })
        //     .catch((err) => {
        //         req();
        //         console.error(err);
        //     });
    }

    /**
   * @name takeWinAmount
   * @description add win amount into wallet balance
   */
    static takeWinAmount() {
        const updatedWallet = DynamicData.getValue(GAME_DATA_KEY.COINS) + DynamicData.getData(GAME_DATA_KEY.WIN).winCoins;
        setWallet(updatedWallet);
    }


    static updateTuroEvent(isFastPlay = true, isAutoSpin = false) {
        // Requests.updateEvent(token, GAME_ID, clientId, { fastPlay: isFastPlay, autoPlay: isAutoSpin })
        //     .then((response) => { })
        //     .catch((err) => {
        //         if (err) {
        //             console.error(err);
        //         }
        //     });
    }
}

export default NetworkController;
